import { BASE_URL_API } from "../../../constants";

export const _api_externe_validation_expense_report = async (hash) => {
    return fetch(BASE_URL_API + "/expense_report/external_manager/" + hash, {
        method: "GET",
        headers: {
            "Content-type": "application/json",
        },
        credentials: "include",
    }).then(async (response) => {
        const data = await response.json();
        return data;
    });
};

export const _api_approve_or_reject_expense_report = async ({
    hash,
    step,
    comment,
}) => {
    return fetch(BASE_URL_API + "/expense_report/external_manager/" + hash, {
        method: "POST",
        headers: {
            "Content-type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ step, comment }),
    }).then(async (response) => {
        const data = await response.json();
        if (response.ok) {
            return data;
        } else {
            throw new Error("Une erreur est survenue !");
        }
    });
};
